import { css } from '@emotion/css';
import colors from '@/theme/colors';

const style = {
  container: css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-decoration: none;
    color: ${colors.prussian};
    margin-bottom: 24px;
    cursor: pointer;
  `,
  content: css`
    display: flex;
    flex-direction: row;
    flex-grow: 1;
  `,
  icon: css`
    padding-right: 8px;
  `,
  arrowIcon: css`
    display: flex;
    align-items: center;
  `,
};

export default style;
